import { render, staticRenderFns } from "./ModalAlertaInformativo.vue?vue&type=template&id=38beaefe&scoped=true&"
import script from "./ModalAlertaInformativo.vue?vue&type=script&lang=ts&"
export * from "./ModalAlertaInformativo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAlertaInformativo.vue?vue&type=style&index=0&id=38beaefe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38beaefe",
  null
  
)

export default component.exports